import React from "react";

export type BadgeType = "success" | "danger" | "info" | "discarded";

type ToggleInputProps = {
    className?: string;
    disabled?: boolean;
    onChange: () => void;
    checked: boolean;
};

const ToggleInput = ({
    className,
    disabled,
    onChange,
    checked,
}: ToggleInputProps): JSX.Element => {
    return (
        <div className={"form-check form-switch " + className}>
            <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                // id="flexSwitchCheckDefault"
                onChange={onChange}
                checked={checked}
            />
            <label
                className="form-check-label"
                // htmlFor="flexSwitchCheckDefault"
            >
                {disabled ? null : checked ? (
                    <p className="m-0 fw-bold text-success">Enabled</p>
                ) : (
                    <p className="m-0 fw-bold text-placeholder-grey">
                        Disabled
                    </p>
                )}
            </label>
        </div>
    );
};

export default ToggleInput;
